import styled, { keyframes } from 'styled-components';

export const Wrapper = styled.div<{ $isSender: boolean; $isPending?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  max-width: 65%;
  min-width: 0;
  margin: 8px 0;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: ${({ $isSender, theme, $isPending }) =>
    $isSender ? ($isPending ? theme.colors.black1 : theme.colors.black2) : theme.colors.green1};
  align-self: ${({ $isSender }) => (!$isSender ? 'flex-start' : 'flex-end')};
  color: ${({ theme, $isPending }) => ($isPending ? theme.colors.black5 : theme.colors.black9)};
`;

export const HtmlWrapper = styled.div`
  min-width: 0;
  max-width: 100%;
  overflow-wrap: break-word;

  & > p {
    margin: 0;

    img {
      max-width: 100%;
    }
  }
`;

export const TimeWrapper = styled.div`
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  opacity: 0.5;
  align-self: flex-end;
`;

const dots = keyframes`
  0% { content: ''; }
  33% { content: '.'; }
  66% { content: '..'; }
  100% { content: '...'; }
`;

export const TextPendingIndicator = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black5};
  &:after {
    display: inline-block;
    width: 1.5em;
    text-align: left;
    content: '';
    animation: ${dots} 1.2s steps(3, end) infinite;
  }
`;

export const FilePendingIndicator = styled.div`
  font-size: 12px;
  background-color: ${({ theme }) => theme.colors.black1};
  padding: 4px 8px;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.black5};
`;

export const FileWrapper = styled.div<{ $pending?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme, $pending }) => ($pending ? theme.colors.black1 : theme.colors.black2)};
  margin-bottom: 8px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: fit-content;
  }
`;

export const FileInfoWrapper = styled.a`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-top: 1px solid ${({ theme }) => theme.colors.black4};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black9};
`;

export const FileIconWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 69px;
  background: ${({ theme }) => theme.colors.black4};
`;

export const ImagePreviewWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;

  /* Opcional: ajustar el espacio entre imágenes */
  gap: 8px;
`;
